
class TimeHM {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.hour = jsonData.hour;
		this.minutes = jsonData.minutes;
	}

	toMinutes() {
		return this.hour * 60 + this.minutes;
	}

	fromMinutes(value) {
		this.hour = Math.trunc(value / 60)
    	this.minutes  = value - (this.hour*60)
	}
	
	equal(otherTime) {
		return this.hour === otherTime.hour && this.minutes === otherTime.minutes;
	}

	isAfter(otherTime) {
		if (this.hour > otherTime.hour)
			return true;
		if (this.hour < otherTime.hour)
			return false
		return this.minutes > otherTime.minutes;
	}

	isBefore(otherTime) {
		if (this.hour < otherTime.hour)
			return true;
		if (this.hour > otherTime.hour)
			return false
		return this.minutes < otherTime.minutes;
	}

	asText() {
    	let hourText = (this.hour > 9) ? this.hour.toString() : "0" + this.hour.toString();
    	let minutesText = (this.minutes > 9) ? this.minutes.toString() : "0" + this.minutes.toString();
    	return hourText + ":" + minutesText;
  	}
}

const minDayTime = () => {
	return new TimeHM({hour: 0, minutes: 0});
}

const maxDayTime = () => {
	return new TimeHM({hour: 24, minutes: 0});
}

class Range {

	constructor(startTime, endTime) {
		this.startTime = startTime;
		this.endTime = endTime;
	}

	asDateText() {
		let sd = new Date(this.startTime);
		let ed = new Date(this.endTime);

		let startDayNumber = sd.toLocaleDateString('es',{day: 'numeric'});
		let startDayName = sd.toLocaleDateString('es',{weekday: 'long'})
		let startMonthName = sd.toLocaleDateString('es',{month: 'long'});
		let startYear = sd.toLocaleDateString('es',{year: 'numeric'});

		if (sd.toDateString() === ed.toDateString()) {
			return `${startDayName} ${startDayNumber} de ${startMonthName} de ${startYear}`
		} else {
			let endDayNumber = ed.toLocaleDateString('es',{day: 'numeric'});
			let endMonthName = ed.toLocaleDateString('es',{month: 'long'});
			let endYear = ed.toLocaleDateString('es',{year: 'numeric'});

			if (startMonthName === endMonthName && startYear === endYear) {
				if (sd.getDate() + 1 === ed.getDate()) {
					return `${startDayNumber} y ${endDayNumber} de ${startMonthName} de ${startYear}`
				} else {
					return `del ${startDayNumber} al ${endDayNumber} de ${startMonthName} de ${startYear}`
				}
			} else {
				return `del ${startDayNumber} de ${startMonthName} al ${endDayNumber} de ${endMonthName} de ${endYear}`
			}

		}
		
	
	}

}

class TimeDate {

	constructor(epoch) {
		this.epoch = epoch;
	}

	asDateText() {
		let date = new Date(this.epoch);

		let dayNumber = date.toLocaleDateString('es',{day: 'numeric'});
		let dayName = date.toLocaleDateString('es',{weekday: 'long'})
		let monthName = date.toLocaleDateString('es',{month: 'long'});
		let year = date.toLocaleDateString('es',{year: 'numeric'});

		return `${dayName} ${dayNumber} de ${monthName} del ${year}`
	}

	asDateTimeText() {
		let date = new Date(this.epoch);

		let dayName = date.toLocaleDateString('es',{weekday: 'long'});
		let day = date.toLocaleDateString('es',{day: 'numeric'});
		let month = date.toLocaleDateString('es',{month: 'numeric'});
		let year = date.toLocaleDateString('es',{year: 'numeric'});
		let hour = date.toLocaleTimeString('es',{hour: '2-digit'});
		let minute = date.toLocaleTimeString('es',{minute: '2-digit'});
		let timehm = new TimeHM({hour: parseInt(hour), minutes: parseInt(minute)});
		
		return `${dayName} ${day}/${month}/${year} - ${timehm.asText()}`
	}

}


export { TimeHM, minDayTime, maxDayTime, Range, TimeDate };